import axiosInstance from './axiosInstance';
import { getMyCastingList } from './castingApi';

/**
 * GET /api/producer/dashboard/summary
 * ⚠️ Backend endpoint required — see docs/backend-requirements.md
 * @returns {{
 *   activeProjects: number,
 *   castingProjects: number,
 *   productionProjects: number,
 *   planningProjects: number,
 *   totalCastings: number,
 *   activeCastings: number,
 *   closedCastings: number,
 *   totalApplicants: number,
 *   totalViews: number,
 *   totalBookmarks: number,
 *   totalApplications: number,
 *   producerApplications: number,
 *   actorApplications: number,
 *   avgRating: number,
 *   reviewCount: number,
 * }}
 */
export const getProducerDashboardSummary = async () => {
  const res = await axiosInstance.get('/api/producer/dashboard/summary');
  return res.data;
};

/**
 * 진행 중인 프로젝트 목록 — adapted from GET /api/castings
 * @param {number} producerProfileId
 * @returns Array<{
 *   id: number,
 *   title: string,
 *   genres: string[],
 *   status: 'CASTING' | 'PRODUCTION' | 'PLANNING' | 'COMPLETED',
 *   applicantCount: number,
 *   deadline: string,   // YYYY-MM-DD
 * }>
 */
export const getProducerProjects = async () => {
  const data = await getMyCastingList();
  const list = data?.content ?? [];
  return list.map(c => ({
    id: c.id,
    title: c.title,
    genres: [c.projectType, c.category].filter(Boolean),
    rawStatus: c.status,
    status: c.status === 'OPEN' ? 'CASTING'
          : c.status === 'IN_PRODUCTION' ? 'IN_PRODUCTION'
          : c.status === 'CLOSED' ? 'COMPLETED'
          : c.status === 'DRAFT' ? 'DRAFT'
          : c.status === 'PLANNING' ? 'PLANNING'
          : 'PLANNING',
    applicantCount: c.applicantCount ?? null,
    viewCount: c.viewCount ?? 0,
    deadline: c.applicationDeadline ?? null,
  }));
};

/**
 * GET /api/producer/applications/recent
 * @returns Array<{
 *   id: number,
 *   actorName: string,
 *   castingTitle: string,
 *   appliedAt: string,   // ISO datetime
 * }>
 */
export const getProducerRecentApplications = async () => {
  const res = await axiosInstance.get('/api/producer/applications/recent');
  return Array.isArray(res.data) ? res.data : [];
};

/**
 * GET /api/producer/schedules
 * @param {{ startDate: string, endDate: string }} params  YYYY-MM-DD
 * @returns Array<{
 *   id: number,
 *   title: string,
 *   startAt: string,    // ISO datetime (no Z, Seoul time)
 *   endAt: string,
 *   location: string,
 * }>
 */
export const getProducerSchedules = async (startDate, endDate) => {
  const res = await axiosInstance.get('/api/producer/schedules', {
    params: { startDate, endDate },
  });
  return Array.isArray(res.data) ? res.data : (res.data?.content ?? []);
};
